export default {
  guest: {
    earn_pts: 'Câștigă {{points}} pct. la această comandă',
    tagline: 'Fii recompensat. La fiecare comandă, de fiecare dată.',
    pick_reward: 'Alege ce vrei când ajungi acolo',
    free_at: 'gratuit la {{points}} pct.',
    save_at: 'economisești {{amount}} la {{points}} pct.',
    nearest: 'cel mai apropiat',
    cta: 'Începe să câștigi — e gratuit',
    already_member: 'Ești deja membru?',
    sign_in: 'Autentifică-te',
  },
  member: {
    earning_free: 'Câștigi mâncare gratuită',
    every_euro_one: 'Fiecare {{amount}} cheltuiți = 1 pct. Răscumpără pentru produse gratuite și reduceri.',
    every_euro_few:
      'Fiecare {{amount}} cheltuit = {{count}} puncte. Răscumpără-le pentru produse gratuite și reduceri.',
    every_euro_other: 'Fiecare {{amount}} cheltuiți = {{count}} pct. Răscumpără pentru produse gratuite și reduceri.',
    until_redeem: '{{remaining}} pct. până poți începe să răscumperi',
    unlock_first: 'Această comandă singură îți deblochează prima recompensă!',
    so_close: 'Ești atât de aproape de mâncare gratuită!',
    just_more: 'Doar {{remaining}} pct. în plus și poți începe să economisești.',
    pts_to_unlock: '{{remaining}} pct. pentru a debloca recompensele',
    this_order_unlocks: 'Această comandă te duce la {{points}} pct. — poți răscumpăra la următoarea comandă!',
    save_next: 'Economisești până la {{amount}} data viitoare',
    pts_from_order: '+{{earned}} pct. din această comandă — mai rămân doar {{remaining}}!',
    rewards_value: '= {{amount}} în recompense',
    save_this_order: 'Economisești până la {{amount}} la această comandă',
    use_pts: 'Folosește-ți cele {{points}} pct. la finalizarea comenzii',
    earned_this_order: '+{{points}} pct. câștigați la această comandă',
    current: 'Curent',
    from_this_order: '+{{points}} din această comandă',
    expiration_zero: '{{points}} pct. expiră astăzi',
    expiration_one: '{{points}} pct. expiră în 1 zi',
    expiration_few: '{{points}} puncte expiră în {{count}} zile',
    expiration_other: '{{points}} pct. expiră în {{count}} zile',
  },
};
